/* eslint-disable react/destructuring-assignment */
import Section13 from '@/components/RouteToCityPage/SectionManager/Section13';
import React from 'react';

function AirlineTicket(props: any) {
  return (
    <Section13
      {...props}
      airline={props.company}
      hideAirline
    />
  );
}

export default React.memo(AirlineTicket);
